/** Business document types (same list as the API's documents/document-types.ts). */
export const DOCUMENT_TYPES = [
  'quotation', 'proforma_invoice', 'order_confirmation', 'invoice', 'receipt', 'delivery_note', 'packing_slip', 'purchase_order',
] as const;
export type DocumentType = typeof DOCUMENT_TYPES[number];
export type DocumentLanguage = 'auto' | 'en' | 'ar' | 'bilingual';
/** Follow the saved template by default; auto explicitly follows the user's app language. */
export type DocumentLanguageChoice = DocumentLanguage | 'template';

/** Documents produced from one order (Orders → Documents). */
export const ORDER_DOCUMENT_TYPES: DocumentType[] = ['proforma_invoice', 'order_confirmation', 'invoice', 'receipt', 'delivery_note'];

export const DOCUMENT_ICONS: Record<DocumentType, string> = {
  quotation: 'document-text-outline',
  proforma_invoice: 'document-outline',
  order_confirmation: 'checkmark-done-outline',
  invoice: 'receipt-outline',
  receipt: 'cash-outline',
  delivery_note: 'car-outline',
  packing_slip: 'cube-outline',
  purchase_order: 'cart-outline',
};

export const isDocumentType = (v: any): v is DocumentType => (DOCUMENT_TYPES as readonly string[]).includes(v);

export type DocumentEvent = 'order_placed' | 'order_confirmed' | 'order_shipped' | 'order_delivered' | 'order_paid';
/** The order event that sends each type automatically (same table as the API's documents/document-message.ts); the others are sent by hand. */
export const DOCUMENT_EVENT_OF_TYPE: Partial<Record<DocumentType, DocumentEvent>> = {
  proforma_invoice: 'order_placed',
  order_confirmation: 'order_confirmed',
  delivery_note: 'order_shipped',
  invoice: 'order_delivered',
  receipt: 'order_paid',
};
